module.exports = __webpack_public_path__ + "img/sales.ce5e93b4.svg";